import React, { useEffect, useState } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import AppDatagridTable from '../../../layouts/AppDatagridTable';

import { useDispatch, useSelector } from 'react-redux';
import { getPageContent, submitForm } from '../../../../store/actions/ProductActions';
import AppLoader from '../../../pages/AppLoader';
import { blogsTable } from '../../../../utils/tableElements';
import moment from 'moment';
import { convertTo12HourFormat } from '../../../../utils/appConstants';
import AppDialogBox from '../../../pages/AppDialogBox';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { addFunctionsToCols } from '../../../../utils/appFunctions';

const ManageBlogs = () => {
  const dispatch = useDispatch();

  const [tableData, setTableData] = useState({});
  const [open, setOpen] = useState(false);
  const [actionId, setActionId] = useState();
  const [values, setValues] = useState({});

  const token = useSelector(state => state?.auth?.token);
  const btnLoaderOne = useSelector(state => state?.app?.btnLoaderOne);
  const blogs = useSelector(state => state?.products?.blogs);

  useEffect(() => {
    dispatch(getPageContent('getAllBlogs'));
    addFunctionsToCols(blogsTable, editBlogs, 'editIcon');
    addFunctionsToCols(blogsTable, deleteBlogs, 'deleteIcon');
  }, []);

  useEffect(() => {
    if (blogs) {
      setTableData({ columns: blogsTable, rows: blogs });
      setOpen(false);
    }
  }, [blogs]);

  function editBlogs(row, col) {
    setValues({
      title: row?.title,
      description: row?.description,
      isTopBlog: row?.isTopBlog ?? false,
    });
    setActionId(row?._id);
    setOpen(true);
  }

  function deleteBlogs(row, col) {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      const submitValues = { isActive: false, isTopBlog: false };
      dispatch(submitForm('editBlog', token, submitValues, row?._id));
    }
  }

  function clearForm() {
    setValues({ title: '', description: '' });
  }

  const handleOpenModal = () => {
    clearForm();
    setOpen(true);
    setActionId();
  };

  const handleSubmit = e => {
    e.preventDefault();
    const type = actionId ? 'editBlog' : 'createBlog';

    let submitValues = { additionalPath: values?.title, ...values };
    dispatch(submitForm(type, token, submitValues, actionId));
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setValues({ ...values, description: data });
  };

  const handleChange = e => {
    setValues({ ...values, [e?.target?.name]: e?.target?.value });
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleFileChange = e => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setValues({ ...values, files });
    }
  };

  return blogs ? (
    <div>
      <AppTitle title='Blogs Management' from='Home' to='Blogs' />

      <div className='container my-5'>
        <div className='text-right mb-3'>
          <button className='btn btn-dark ' onClick={handleOpenModal}>
            Add Blog
          </button>
        </div>

        <AppDatagridTable tableData={tableData} />

        <AppDialogBox
          title={actionId ? 'Edit Product' : 'Add Product'}
          setOpen={setOpen}
          open={open}
          size='md'
          disableBackdropClick={false}
        >
          <form onSubmit={handleSubmit}>
            <div className='form-group'>
              <label>Name *</label>
              <input
                type='text'
                placeholder='Blog title'
                className='form-control'
                required
                name='title'
                value={values?.title}
                onChange={handleChange}
              />
            </div>

            <div className='form-group my-3'>
              <label>Description</label>

              <CKEditor
                editor={ClassicEditor}
                config={{
                  licenseKey: 'GPL', // Or 'GPL'.

                  initialData: values?.description ?? '',
                }}
                data={values?.description}
                onChange={handleEditorChange}
              />
            </div>

            <div className='form-group'>
              <label>Image (Should be less than 300kb)*</label>
              <input
                type='file'
                placeholder='Product price'
                className='form-control'
                // required={!actionId}
                name='files'
                // multiple
                onChange={handleFileChange}
                accept='image/*'
              />
            </div>

            <div className='single-method form-check mt-3'>
              <input
                className='form-check-input'
                type='checkbox'
                id='accept_terms'
                checked={values?.isTopBlog}
                onChange={e => setValues({ ...values, isTopBlog: e?.target?.checked })}
              />
              <label className='form-check-label' for='accept_terms'>
                Mark as top blog
              </label>
            </div>

            <div className='text-right mt-2 mb-3'>
              <Button variant='contained' type='submit' disabled={btnLoaderOne}>
                {btnLoaderOne ? 'Submitting...' : 'Submit'}
              </Button>

              <Button variant='contained' className='mx-2' color='error' onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </form>
        </AppDialogBox>
      </div>
    </div>
  ) : (
    <AppLoader />
  );
};

export default ManageBlogs;
